//TOASTER
import { toast } from "react-toastify";


import { version } from '../../package.json';

//API ATIVAR configuração para produção
export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const API_VALIDACAO_EMAIL_URL = process.env.REACT_APP_API_VALIDADOR_URL;
export const API_CAMPAIGN_URL = process.env.REACT_APP_API_CAMPAIGN_URL;
export const API_AUTH_URL = process.env.REACT_APP_API_AUTH;
export const VERSAO = version;

// API TINYMCE
export const API_TINY_KEY = process.env.REACT_APP_TINY_KEY;

//ROUTING
export const DEFAULT_PUBLIC_ROUTE = "/login";
export const DEFAULT_PRIVATE_ROUTE = "/campanha/painel";

export const LOGIN_ROUTE = "/login";
export const PANEL_ROUTE = "/campanha/painel";
export const CAMPAIGN_ROUTE = "/campanha";
export const STAMP_ROUTE = "/carimbo";
export const REPORT_ROUTE = "/relatorio";
export const REPORT_ROUTE_CARIMBO = "/relatorio/verifica-montreal-toi";
export const REPORT_USUARIO = "/config";
export const RECUPERAR_SENHA = "/recuperar-senha";
export const TROCA_SENHA = "/redefinir-senha";
export const VALIDATION_ROUTE = "/validacao-email";
export const ENVIO_SMS_ROUTE = "/envio-sms";
export const MODULO = "/modulo";


//NAV ITEMS
export const NAV_PANEL = 'painel';
export const NAV_CAMPAIGN = 'campanha';
export const NAV_STAMP = "carimbo";
export const NAV_REPORT = 'relatorio';
export const NAV_VERIFICA_MONTREAL = 'verificaMontreal';
export const NAV_VALIDATION = 'validacaoEmail';
export const NAV_ENVO_SMS = 'envioSms';
export const NAV_LAUDO_DOWNLOAD = 'laudoDownload';
export const NAV_UPLOADTOI = 'uploadToi';


//ERROR HANDLING
export const SUCCESS = "success";
export const OBJECT_SUCCESS = { className: SUCCESS, autoClose: 6000 };

export const WARNING = "warning";
export const OBJECT_WARNING = { className: WARNING, autoClose: 6000 };

export const ERROR = "error";
export const OBJECT_ERROR = { className: ERROR, autoClose: 6000 };

export const INFO = "info";
export const OBJECT_INFO = { className: INFO, autoClose: 6000 };

//DEFAULT MESSAGES
export const DEFAULT_ERROR = "Ocorreu um erro inesperado :/";
export const NETWORK_ERROR = "Ocorreu um erro ao comunicar com o servidor :/";
export const AUTH_ERROR = "Usuário não autenticado.";
export const UNAUTHORIZED_ERROR = "Não autorizado.";

//DEFAULT PAGINATION VALUES
export const DEFAULT_PAGE_RANGE = 5;

//TEXT EDITOR TYPES
export const SIMPLE_TEXT_EDITOR = "simples";
export const HTML_TEXT_EDITOR = "html";

//API PAINEL
export const EMAILS_ENVIADOS = API_BASE_URL + "/emailsSent";
export const ULTIMAS_CAMPANHAS = API_BASE_URL + "/lastCampaigns";
export const ENVIO_MENSAL = API_BASE_URL + "/sendMonthly";
export const ENVIO_TRIMESTRAL = API_BASE_URL + "/sendLastThreeMonthly";
export const DASHBOARD = API_BASE_URL + "/dashboard";
export const REDEFINIR_SENHA = API_BASE_URL + "/recuperarSenha";
export const VALIDACAO_EMAIL = API_VALIDACAO_EMAIL_URL;



//AUTH FUNCTIONS
export function AUTH_HEADER(token) {
    if (token) return "Bearer " + token;
    else return "";
}

//ERROR HANDLING FUNCTIONS
export function MESSAGE_SUCCESS(message, details) {
    if (message === undefined) message = "Sucesso!";
    if (details === undefined) details = null;

    return { type: "success", message: message, details: details }
}

export function MESSAGE_WARNING(message, details) {
    if (message === undefined) message = "Alerta.";
    if (details === undefined) details = null;

    return { type: "warning", message: message, details: details }
}

export function MESSAGE_ERROR(message, details) {
    if (message === undefined) message = "Ocorreu um erro inesperado :/";
    if (details === undefined) details = null;

    return { type: "error", message: message, details: details }
}

export function MESSAGE_INFO(message, details) {
    if (message === undefined) message = "Informação.";
    if (details === undefined) details = null;

    return { type: "info", message: message, details: details }
}

//TOASTER FUNCTIONS
export function TOASTER(type, message) {
    switch (type) {
        case SUCCESS:
            type = OBJECT_SUCCESS;
            break;
        case WARNING:
            type = OBJECT_WARNING;
            break;
        case ERROR:
            type = OBJECT_ERROR;
            break;
        case INFO:
            type = OBJECT_INFO;
            break;
        default:
            type = OBJECT_INFO;
            break;
    }

    toast(message, type);
}

export function TOASTER_SUCCESS(message) {
    toast(message, OBJECT_SUCCESS);
}

export function TOASTER_WARNING(message) {
    toast(message, OBJECT_WARNING);
}

export function TOASTER_ERROR(message) {
    toast(message, OBJECT_ERROR);
}

export function TOASTER_INFO(message) {
    toast(message, OBJECT_INFO);
}

export function TOASTER_ERROR_LINES(message) {
    const lines = message.split('<br>');
    lines.forEach(line => {
        if (line.trim().length > 0) {
            toast(line, OBJECT_ERROR);
        }
    });
}

